module.exports = __webpack_public_path__ + "img/institutional-parceiros.6c0e854f.webp";